import request from "@/utils/request";

/**
 * 列表
 * @param data
 * @returns {AxiosPromise}
 */
export const lxfsList = (data) =>  request({
  method: 'post',
  url: `/organization/api/xzqhLxdh/list`,
  data: data
})
/**
 * 新增
 * @param data
 * @returns {AxiosPromise}
 */
export const addLxzfsSave = (data) =>  request({
  method: 'post',
  url: `/organization/api/xzqhLxdh/add`,
  data: data
})

/**
 * 修改
 * @param data
 * @returns {AxiosPromise}
 */
export const editLxzfsSave = (data) =>  request({
  method: 'put',
  url: `/organization/api/xzqhLxdh/edit`,
  data: data
})

/**
 * 删除
 * @param data
 * @returns {AxiosPromise}
 */
export const removeLxzfsSave = (xzqhId) =>  request({
  method: 'delete',
  url: `/organization/api/xzqhLxdh/remove/${xzqhId}`
})
